export default __webpack_public_path__ + "static/media/pexels-karolina-grabowska-4491461.60ce3e2e.jpg";